// ── AML proposed config (v2), sectionized by config file ────────────────────
//
// Mockup only (local state, never written to the workflow JSON). In v2 you
// configure the AML provider CONNECTOR for this node's provider, plus the
// ongoing-monitoring registration:
//   con_complyadvantage  — ComplyAdvantage (fuzziness, profiles, monitoring)
//   con_refinitiv        — LSEG World-Check (group ids, creds)
//   con_aml_update       — ongoing monitoring registration (nightly updates)
import { useState } from 'react'
import { Field, SelectInput, TextInput, Toggle } from './fields'
import { ConfigSection } from './ConfigSection'

function ComplyAdvantageSection() {
  const [base, setBase] = useState('https://api.complyadvantage.com')
  const [auth, setAuth] = useState('SECRET:production/frankie_kyc/connectors/defaults')
  const [defaultProfile, setDefaultProfile] = useState('pep')
  const [stringency, setStringency] = useState('0.3')
  const [ongoing, setOngoing] = useState(true)
  const [pepUuid, setPepUuid] = useState('da698b36-f596-4ca9-8367-484cb203271b')
  const [pepMediaUuid, setPepMediaUuid] = useState('d30deb3b-0d65-4b16-9e9a-137d61aa9ee0')
  return (
    <ConfigSection title="ComplyAdvantage connector" file="con_complyadvantage" defaultOpen>
      <Field label="Base URL"><TextInput value={base} onChange={(e) => setBase(e.target.value)} /></Field>
      <Field label="Auth (secret path)"><TextInput value={auth} onChange={(e) => setAuth(e.target.value)} placeholder="SECRET:…" /></Field>
      <Field label="Default search profile">
        <SelectInput value={defaultProfile} onChange={(e) => setDefaultProfile(e.target.value)}>
          <option value="pep">pep — PEP + Sanctions</option>
          <option value="pep_media">pep_media — PEP + Sanctions + Adverse Media</option>
        </SelectInput>
      </Field>
      <Field label="Fuzziness / stringency (0–1)"><TextInput type="number" value={stringency} onChange={(e) => setStringency(e.target.value)} placeholder="0.3" /></Field>
      <p className="text-[10px] text-[#5b6b85] -mt-1">Higher = stricter matching, fewer false positives. 0.3 is standard.</p>
      <Toggle label="Ongoing monitoring on by default" checked={ongoing} onChange={setOngoing} />
      <Field label="PEP profile UUID"><TextInput value={pepUuid} onChange={(e) => setPepUuid(e.target.value)} /></Field>
      <Field label="PEP + media profile UUID"><TextInput value={pepMediaUuid} onChange={(e) => setPepMediaUuid(e.target.value)} /></Field>
    </ConfigSection>
  )
}

function RefinitivSection() {
  const [baseUrl, setBaseUrl] = useState('https://api.worldcheck.refinitiv.com')
  const [apiKey, setApiKey] = useState('SECRET:.../refinitiv/api_key')
  const [apiSecret, setApiSecret] = useState('SECRET:.../refinitiv/api_secret')
  const [pepGroup, setPepGroup] = useState('')
  const [pepMediaGroup, setPepMediaGroup] = useState('')
  return (
    <ConfigSection title="LSEG World-Check connector" file="con_refinitiv" defaultOpen>
      <Field label="Base URL"><TextInput value={baseUrl} onChange={(e) => setBaseUrl(e.target.value)} /></Field>
      <Field label="API key (secret path)"><TextInput value={apiKey} onChange={(e) => setApiKey(e.target.value)} placeholder="SECRET:…" /></Field>
      <Field label="API secret (secret path)"><TextInput value={apiSecret} onChange={(e) => setApiSecret(e.target.value)} placeholder="SECRET:…" /></Field>
      <Field label="Group ID — pep (PEP + Sanctions + Watchlist)"><TextInput value={pepGroup} onChange={(e) => setPepGroup(e.target.value)} placeholder="group-uuid" /></Field>
      <Field label="Group ID — pep_media (+ Adverse Media)"><TextInput value={pepMediaGroup} onChange={(e) => setPepMediaGroup(e.target.value)} placeholder="group-uuid" /></Field>
      <p className="text-[10px] text-[#5b6b85]">Note: pep_media (adverse media) needs a separate LSEG agreement per customer.</p>
    </ConfigSection>
  )
}

function AmlUpdateSection() {
  const [enabled, setEnabled] = useState(false)
  const [cidCcid, setCidCcid] = useState('customer-id:customer-child-id')
  return (
    <ConfigSection title="Ongoing monitoring registration" file="con_aml_update">
      <Toggle label="Enable nightly monitoring fetch" checked={enabled} onChange={setEnabled} />
      <Field label="Customer id : child id">
        <TextInput value={cidCcid} onChange={(e) => setCidCcid(e.target.value)} placeholder="customer-id:customer-child-id" />
      </Field>
      <p className="text-[10px] text-[#5b6b85]">Registers this customer with the AML monitoring orchestrator for nightly updates.</p>
    </ConfigSection>
  )
}

export function AmlProposedConfig({ provider = '' }: { provider?: string }) {
  const isRefinitiv = provider.toLowerCase().includes('refinitiv') || provider.toLowerCase().includes('worldcheck')
  return (
    <>
      {isRefinitiv ? <RefinitivSection /> : <ComplyAdvantageSection />}
      <AmlUpdateSection />
    </>
  )
}
